
import React from 'react';
import { Loader2 } from 'lucide-react';

interface CustomerLoadingProps {
  message?: string;
  small?: boolean;
}

const CustomerLoading = ({ message = "Chargement des clients...", small = false }: CustomerLoadingProps) => {
  if (small) {
    return (
      <div className="flex items-center justify-center py-3 px-4">
        <Loader2 className="h-4 w-4 text-primary animate-spin mr-2" />
        <span className="text-sm text-muted-foreground">{message}</span>
      </div>
    );
  }
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <Loader2 className="h-8 w-8 text-primary animate-spin mb-4" />
      <p className="text-center text-muted-foreground">{message}</p>
    </div>
  );
};

export default CustomerLoading;
